import React, { Fragment, useEffect, useState } from 'react';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { get, isNil } from 'lodash';
import { Check } from 'lucide-react';

import Header from 'components/Header';
import { Grid, Column } from 'components/Layout';
import { Button } from 'components/Button';
import { nextAction } from 'actions/workflow';

import style from './style.scss';

const Congratulations = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const key = searchParams.get('key');
  const workflowType = searchParams.get('workflowtype');
  const applicationId = useSelector(state => get(state, 'workflow.entityId', get(state, 'workflow.attributes.entityId', '')));
  const data = useSelector(state => get(state, 'workflow.data.data') || get(state, 'workflow.state.data'));

  useEffect(() => {
    if (!key) {
      navigate('/dashboard');
    } else if (isNil(data)) {
      navigate(`/applications/fsl/checkin?key=${key}`);
    }
  }, []);

  const handleButtonClick = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    dispatch(nextAction({
      data: {},
      url: `/workflows/fsl/${key}/next`,
      success: (res) => {
        setIsSubmitting(false);
        const nextUrl = get(res, 'data.url') || get(res, 'state.url');
        if (nextUrl) navigate(nextUrl);
      },
      fail: (err) => {
        setIsSubmitting(false);
        navigate(`/applications/${workflowType}/error?key=${key}`, {
          state: {
            message: get(err, 'data.message')
              || get(err, 'data.failure.errors.0.message')
              || 'An error occurred',
          },
        });
      },
    }));
  };

  return (
    <Fragment>
      <Header />
      <section className="container section">
        <div className={cn('use-tailwind grid-container fluid', style['congrats-page'])}>
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">
              {applicationId ? (
                <div className="cell small-12 medium-12" style={{ textAlign: 'left' }}>
                  <p className="mb-0 p-large"><b>Application ID:</b> {applicationId}</p>
                </div>
              ) : null}

              <Column className="small-12 large-8 large-offset-2 text-center mt-4">
                <div className="flex flex-col items-center max-w-md mx-auto">
                  <div className="rounded-full border-4 border-green-500 p-4 mb-8">
                    <Check className="w-12 h-12 text-green-500" strokeWidth={3} />
                  </div>
                  <h1 className="text-4xl font-bold text-slate-800 mb-6">Thank you!</h1>
                  <p className="text-center text-gray-500 text-lg mb-10">
                    Before we can submit your credit application, we need to verify your income and your monthly payments to {get(data, 'dbaName')}.
                  </p>

                  <Button
                    className="button green w-full text-white py-4 px-6 rounded-md !border-0 leading-[inherit] font-normal"
                    onClick={handleButtonClick}
                    isLoading={isSubmitting}
                  >
                    Next: Verify Bank Account
                  </Button>
                </div>
              </Column>
            </Grid>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Congratulations;
